import { useRef } from "react";
import { Helmet } from "react-helmet";
import "../Terms/styled.scss";
import "../../../home.scss";
import { Link } from "react-router-dom";

const SmsTermsHeader = () => {
  return (
    <div className="section terms_head" style={{}}>
      <div className="content_container">
        <div
          className="content terms_head"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="terms_head_left">
            <h1>SMS Terms of Service</h1>
          </div>
        </div>
      </div>
    </div>
  );
};
const SmsTermsContent = () => {
  return (
    <div className="section terms" style={{}}>
      <div className="content_container" style={{}}>
        <div className="content terms">
          <div className="terms_body">
            <div className="terms_sec">
              <div className="content">
                <ol>
                  <li>
                    <p>
                      Brandclub’s SMS Service (the “SMS Service”) allows us to
                      send messages to Brandclub customers who have verified
                      their mobile number and opted into the SMS service.
                    </p>
                  </li>
                  <li>
                    <p>
                      By agreeing to these SMS Terms of Service, you authorize
                      Brandclub to send transaction updates and marketing
                      communications through our SMS Service.
                    </p>
                  </li>
                  <li>
                    <p>
                      You can cancel the SMS Service at any time. Just message
                      "STOP" to the number from which you received your message.
                      After you message "STOP," we will send you a confirmation
                      that you have been unsubscribed. After this, you will no
                      longer be able to make purchases through any Brandclub
                      service. If you want to join again, please text “START” or
                      “UNSTOP” to your original message.
                    </p>
                  </li>
                  <li>
                    <p>
                      If you are experiencing issues with the messaging program
                      you can reply with the keyword "HELP" for more assistance
                      or simply click “
                      <Link to="/contact/support">Contact Us</Link>.”
                    </p>
                  </li>
                  <li>
                    <p>
                      Carriers are not liable for delayed or undelivered
                      messages.
                    </p>
                  </li>
                  <li>
                    <p>
                      As always, standard message and data rates may apply for
                      any messages sent to you from us and to us from you.
                      Message frequency varies. If you have any questions about
                      your text plan or data plan, please contact your wireless
                      provider.
                    </p>
                  </li>
                  <li>
                    <p>
                      If you have any questions regarding privacy, please check
                      out Brandclub’s <Link to="/privacy">Privacy Policy</Link>.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SmsTerms = () => {
  const ref = useRef(undefined) as any;
  const disable = false;
  if (disable) {
    return <></>;
  }
  return (
    <div className="site" style={{ height: "unset" }} ref={ref}>
      <Helmet>
        <title>Reward Terms</title>
        <meta
          name="description"
          content="Learn more about our key terms and policies regarding rewards."
        />
      </Helmet>
      <SmsTermsHeader />
      <SmsTermsContent />
    </div>
  );
};
export default SmsTerms;
